<template>
  <div id="app" @touchstart="resetTimer()" @click="resetTimer()">
    <heading ref="header"></heading>
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: "App",
  components: {
    heading: Header
  },
  data() {
    return {
      timeout: 0
    };
  },
  created() {
    this.startTimeout();
  },
  methods: {
    startTimeout() {
      this.timeout = window.setTimeout(() => {
        this.goTo("/");
        window.location.reload();
      }, 1440000);
    },
    resetTimer(image = false) {
      let vm = this;
      window.clearTimeout(vm.timeout);
      this.startTimeout();
    }
  }
};
</script>

<style lang='scss' src="../public/css/main.scss"></style>
